/* eslint-disable react-hooks/exhaustive-deps */
import { useSplitTreatments } from '@splitsoftware/splitio-react';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../providers/AuthProvider';

export const useEllisDTFlag = () => {
  const featureFlag = 'devx-ellis-dt-chat';
  const { profEmail } = useContext(AuthContext);

  const { treatments } = useSplitTreatments({
    names: [featureFlag],
    splitKey: profEmail?.toLowerCase() || 'anonymous',
  });

  // Fallback to default values
  const [promptLibraryEnabled, setPromptLibraryEnabled] = useState(true);
  const [attachmentsEnabled, setAttachmentsEnabled] = useState(true);
  const [knowledgeGraphEnabled, setKnowledgeGraphEnabled] = useState(true);

  useEffect(() => {
    if (treatments[featureFlag]?.config) {
      console.log('Ellis DT treatments: ', treatments);
      const configObj = JSON.parse(treatments[featureFlag].config);
      const newPromptLibraryEnabled = configObj.promptLibrary !== 'false';
      const newAttachmentsEnabled = configObj.attachments !== 'false';
      const newKnowledgeGraphEnabled = configObj.knowledgeGraph !== 'false';

      if (newPromptLibraryEnabled !== promptLibraryEnabled) {
        setPromptLibraryEnabled(newPromptLibraryEnabled);
      }
      if (newAttachmentsEnabled !== attachmentsEnabled) {
        setAttachmentsEnabled(newAttachmentsEnabled);
      }
      if (newKnowledgeGraphEnabled !== knowledgeGraphEnabled) {
        setKnowledgeGraphEnabled(newKnowledgeGraphEnabled);
      }
    }
  }, [
    treatments,
    promptLibraryEnabled,
    attachmentsEnabled,
    knowledgeGraphEnabled,
  ]);

  return { promptLibraryEnabled, attachmentsEnabled, knowledgeGraphEnabled };
};
